
import * as defaultImport from "chroma-js";
export * from "chroma-js";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
